import React, { useState } from "react";
import { Container } from "@mui/material";
import BudgetCard1 from "../../../Components/budget/BudgetCard1";
import BudgetTable1 from "../../../Components/budget/BudgetTable1";

//FUNCTION
const BudgetPage1 = () => {
  //#region code
  const [editData, setEditData] = useState({})
  const [isChanged, setIsChanged] = useState(false)

  const handleEdit = (data) => {
      setEditData(data[0]);
  }

  //#endregion
  return (
      <>
          <Container>
              <BudgetCard1 editData={editData} setEditData={setEditData} isChanged={isChanged} setIsChanged={setIsChanged} />
              <BudgetTable1 handleEditData={handleEdit} isChanged={isChanged} />
          </Container>
      </>
  )
}

export default BudgetPage1;
